import React, { useContext, useRef } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import * as S from "components/common/Input/style";
import ErrorMsg from "./ErrorMsg";
import { getDropdownIndicator } from "./HelperFunctions";
import { LabelsContext } from "helpers/contexts";

DesktopSelectInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  onMenuOpen: PropTypes.func,
  onMenuClose: PropTypes.func,
  options: PropTypes.array.isRequired, //an array of object contains label and value for every option [{label: '', value: ''}]
  selectedValue: PropTypes.object,
  isSearchable: PropTypes.bool,
  iconInlineMargin: PropTypes.string,
  iconColor: PropTypes.string,
  iconSize: PropTypes.string,
  errorMsg: PropTypes.string,
  colorStyles: PropTypes.object,
  value: PropTypes.object,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isInitiallyOpen: PropTypes.bool,
};

DesktopSelectInput.defaultProps = {
  placeholder: "",
};

function DesktopSelectInput(props) {
  const self = useRef(null);
  const labels = useContext(LabelsContext);
  const iconName = props.disabled ? ICON_NAME.lock : ICON_NAME.default;

  const DropdownIndicator = () => {
    return getDropdownIndicator(
      iconName,
      props.iconSize,
      props.iconColor,
      props.iconInlineMargin
    );
  };

  return (
    <S.SelectContainer>
      <Select
        onChange={props.onChange}
        onMenuClose={props.onMenuClose}
        onMenuOpen={props.onMenuOpen}
        options={props.options}
        components={{ DropdownIndicator }}
        noOptionsMessage={() => labels.selectInput.notFound}
        styles={props.colorStyles}
        value={props.value}
        placeholder={props.placeholder}
        isDisabled={props.disabled}
        isClearable
        isSearchable={props.isSearchable}
        menuPortalTarget={self.current?.closest(".MuiDialog-root")}
        menuPlacement={"auto"}
        defaultMenuIsOpen={props.isInitiallyOpen}
        autoFocus={props.isInitiallyOpen}
      />
      <div style={{ visibility: "hidden" }} ref={self} />
      {props.errorMsg && <ErrorMsg errorMsg={props.errorMsg} />}
    </S.SelectContainer>
  );
}

const ICON_NAME = { default: "angle-down-small", lock: "lock-empty" };

export default DesktopSelectInput;
